import React, { FormEvent } from "react";
import ReactModal from "react-modal";

interface IDialogBaseProps {
    isOpen: boolean;
    title: string;
    className?: string;

    onRequestClose?: (event?: (React.MouseEvent | React.KeyboardEvent)) => void;
    onSubmit?: () => PromiseLike<void>;
    onSuccess?: () => void;
}

class DialogBase extends React.Component<IDialogBaseProps> {
    constructor(props: Readonly<IDialogBaseProps>) {
        super(props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.requestClose = this.requestClose.bind(this);
    }

    public render() {
        if (!this.props.isOpen) {
            return null;
        }

        return (
            <ReactModal
                isOpen={this.props.isOpen} onRequestClose={this.requestClose}
                overlayClassName="modal-overlay" className={"modal-content " + (this.props.className || "")} portalClassName="modal-deletion-portal"
                bodyOpenClassName="modal-deletion-open"
                contentLabel={this.props.title}>
                <form className="input-form" onSubmit={this.handleFormSubmit}>
                    <section className="info-block">
                        <header>
                            <h3>{this.props.title}</h3>
                        </header>

                        {this.props.children}
                    </section>
                </form>
            </ReactModal>
        );
    }

    private requestClose(e?: (React.MouseEvent | React.KeyboardEvent)) {
        if (this.props.onRequestClose) {
            this.props.onRequestClose(e);
        }
    }

    private async handleFormSubmit(e: FormEvent) {
        e.preventDefault();

        if (this.props.onSubmit) {
            await this.props.onSubmit();
        }

        if (this.props.onSuccess) {
            this.props.onSuccess();
        }

        this.requestClose();
    }
}

export default DialogBase;
